import { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { useRoute } from 'src/router/hooks/useRoute';
import { Button } from 'src/components/Buttons/Button';

export const CookiesBanner = () => {
  const { ROUTE } = useRoute();
  const [showBanner, setShowBanner] = useState<boolean>(false);
  const { t } = useTranslation();
  const onAcceptCookiesClick = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    window.dispatchEvent(new Event('storage'));
    setShowBanner(false);
  };

  useEffect(() => {
    if (!localStorage.getItem('cookiesAccepted')) {
      setShowBanner(true);
    }
    if (localStorage.getItem('cookiesAccepted') === 'true') {
      setShowBanner(false);
    }
  }, []);

  if (!showBanner) return null;

  return (
    <div className='flex items-center justify-center bg-cb_bg w-full px-7 py-3 z-[500]'>
      <div className="flex items-center 768:min-w-[700px] pointer-events-auto">
        <p className="text-cb_text text-sm 768:text-base text-center 768:font-bold mr-6 flex-1">
          <Trans
            i18nKey="cookiesBanner.text"
            components={{
              1: (
                <Link
                  target="_blank"
                  to={ROUTE.INFO_PAGES_POLICY.get()}
                  className="font-bold cursor-pointer text-cb_link underline"
                />
              )
            }}
          />
        </p>
        <Button
          title="ok"
          mode="button-secondary"
          className="max-w-[60px] max-h-[30px] 768:min-w-[120px]"
          onClick={onAcceptCookiesClick}>
          {t('cookiesBanner.ok')}
        </Button>
      </div>
    </div>
  );
};
